<template>
  <div id="app">
    <h-header></h-header>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <div v-if="loading" class="loading-overlay">
      <img :src="require('@/static/img/loading.gif')" alt="Loading" />
    </div>
  </div>
</template>

<script>

import HHeader from "@/page/components/h-header";
export default {
  name: 'App',
  components: {
    HHeader
  },
  computed: {
    loading() {
      return  this.$store.state.commonStore.loading;
    },
  },
  mounted() {
    // console.log(process.env);
  }
}
</script>

<style>
/*路由切换过场*/
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
  padding-top: 60px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  z-index: 99;
}
.loading-overlay img{
  width: 50px;
  height: 50px;
}
</style>
